import {
  LOAD_MARKETS,
  SET_MARKETS,
  SET_MARKET_DETAIL,
  SET_MARKET_OHLC,
  GET_FAV_MARKETS,
  SET_BASE_CURR_EXCH_RATE,
  SET_QUOTE_CURR_EXCH_RATE,
} from '../actions/marketsActions'
import MarketModel from '../../models/MarketModel'
import { OHLCData, MarketDetail } from '../types'

export interface MarketsState {
  markets: MarketModel[]
  favMarkets: any[]
  marketDetail: MarketDetail | false
  loading: boolean
  ohlc: OHLCData[]
  baseCurrExchRate: number
  quoteCurrExchRate: number
}

interface MarketsAction {
  type: string
  markets?: MarketModel[]
  favMarkets?: any[]
  marketDetail?: MarketDetail
  ohlc?: OHLCData[]
  baseCurrExchRate?: number
  quoteCurrExchRate?: number
}

const initialState: MarketsState = {
  markets: [],
  favMarkets: [],
  marketDetail: false,
  loading: false,
  ohlc: [],
  baseCurrExchRate: 1,
  quoteCurrExchRate: 1,
}

const marketsReducer = (state: MarketsState = initialState, action: MarketsAction): MarketsState => {
  switch (action.type) {
    case LOAD_MARKETS:
      return {
        ...state,
        loading: true,
      }
    case SET_MARKETS:
      return {
        ...state,
        loading: false,
        markets: action.markets || [],
      }
    case GET_FAV_MARKETS:
      return {
        ...state,
        favMarkets: action.favMarkets || [],
      }
    case SET_MARKET_DETAIL:
      return {
        ...state,
        marketDetail: action.marketDetail || false,
      }
    case SET_MARKET_OHLC:
      return {
        ...state,
        ohlc: action.ohlc || [],
      }
    case SET_BASE_CURR_EXCH_RATE:
      return {
        ...state,
        baseCurrExchRate: action.baseCurrExchRate || 1,
      }
    case SET_QUOTE_CURR_EXCH_RATE:
      return {
        ...state,
        quoteCurrExchRate: action.quoteCurrExchRate || 1,
      }
    default:
      return state
  }
}

export default marketsReducer 